module.exports = __webpack_public_path__ + "src/assets/games/9/150.jpg";